module.exports = __webpack_public_path__ + "img/icon2.eaf6eab1.png";